import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const KyrgyzstanMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Kyrgyzstan</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">
              MD (Doctor of Medicine) — equivalent to MBBS in India
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              5 years (4.5 years academics + 1-year internship)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks in PCB</li>
              <li>NEET qualification mandatory (for Indian students)</li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">English</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">NMC (India), WHO, ECFMG, WFME</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Advantages:</h3>
            <p className="detail-text">
              Affordable tuition, Indian food widely available, no donation or
              entrance exams.
            </p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top Medical Universities in Kyrgyzstan
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Kyrgyz State Medical Academy (KSMA), Bishkek
              </h3>
              <p className="university-description">
                Oldest and most reputed government medical university.
                Recognized by NMC and WHO.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Osh State University – Medical Faculty, Osh
              </h3>
              <p className="university-description">
                Popular among Indian students. Affordable and well-established
                university.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Jalal-Abad State University (JASU), Jalal-Abad
              </h3>
              <p className="university-description">
                Government university with a good MBBS program in English.
                Recognized by WHO and NMC.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                International School of Medicine (ISM), Bishkek
              </h3>
              <p className="university-description">
                Private medical school under the International University of
                Kyrgyzstan. Offers English-medium MD program; popular choice for
                Indians.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Asian Medical Institute (ASMI), Kant
              </h3>
              <p className="university-description">
                Affordable tuition. Indian faculty and hostels available.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Kyrgyz Russian Slavic University (KRSU), Bishkek
              </h3>
              <p className="university-description">
                Jointly operated by Russia and Kyrgyzstan. High academic
                standards and recognized globally.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Avicenna International Medical University, Bishkek
              </h3>
              <p className="university-description">
                Newer private university. NMC and WHO recognized; good
                facilities for international students.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default KyrgyzstanMbbs;
